module.exports = __webpack_public_path__ + "static/img/icon_sr.3acd3180.png";